module.exports = __webpack_public_path__ + "static/media/accessories-5.f25de020.jpg";